import React, { useEffect, useState } from 'react';
import { Layout } from '../../../components';
import { Tnews, initialNews } from '../../../type/news';
import { useParams } from 'react-router-dom';
import { getDataDetail } from '../../../service/newsServise';
import { MINIO } from '../../../data/data';
import { FiCalendar } from 'react-icons/fi';

const DetailNews = () => {
    const [news, setNews] = useState<Tnews>(initialNews)

    const { slug } = useParams();

    const getDataNewsDetail = async (slug: string) => {
        const response = await getDataDetail(slug);
        if (!response?.error) {
            setNews(response?.data)
        }
    }

    useEffect(() => {
        getDataNewsDetail(slug || "")
    }, [])

    return (
        <Layout title='News' showNavBar={true} showNavigation={false}>
            <div className='mt-[4rem]'>
                <div className='bg-gray-50 text-center overflow-hidden rounded-sm mb-4'>
                    <img src={`${MINIO}/${news.thumbnail}`} className='' alt={news.name} />
                </div>
                <h2 className='text-[18px] font-medium mt-2'>{news.name}</h2>
                <span className='text-[10px] text-gray-400 m-0 p-0 flex item-center'>
                    <FiCalendar className='mr-2' />
                    {new Date(news.createDate).toLocaleDateString()} - {new Date(news.createDate).toLocaleTimeString()}
                </span>
                <div className='mt-2' dangerouslySetInnerHTML={{ __html: news.content }} />
            </div>
        </Layout>
    );
};

export default DetailNews;